import React, { useState } from "react";
import { getFirestore, collection, addDoc, serverTimestamp } from "firebase/firestore";
import { message, Steps, theme } from "antd";
import "./Form.css";
import { getAuth } from "firebase/auth";

import { StepOne } from "./StepOne";
import { StepTwo } from "./StepTwo/StepTwo";
import { StepThree } from "./StepThree";
import { getSerial, getUserData, APP_VERSION } from "../../../utils";
import { logUserAction } from "../../../logs";

export const FormAddSales = () => {
  const querydb = getFirestore();
  const auth = getAuth();

  const { token } = theme.useToken();
  const [current, setCurrent] = useState(0);
  const next = () => {
    setCurrent(current + 1);
  };
  const prev = () => {
    setCurrent(current - 1);
  };

  const [dataFormClient, setDataFormClient] = useState();
  const [dataFormProduct, setDataFormProduct] = useState([]);
  const [dataFormSale, setDataFormSale] = useState();

  const onSubmit = async (values, imgSale) => {
    try {
      const ordersCollection = collection(querydb, "orders");

      // contains order products
      const items = [];

      // eslint-disable-next-line
      dataFormProduct?.map((ele, i) => {

        items.push({ ...ele, color: ele.color.toUpperCase() });

      });

      const serialStart = new Date();
      const serial = await getSerial(querydb);
      const serialEnd = new Date();
      const serialDuration = serialEnd - serialStart;

      const userData = await getUserData(querydb, auth.currentUser.uid);
      const seller = `${userData.name} ${userData.surname}`;

      await addDoc(ordersCollection, {
        ...dataFormClient,
        ...values,
        products: items,
        fileImage: imgSale ? [imgSale.fileImage] : [],
        status: "Pendiente",
        seller: seller,
        serial: serial,
        courier: "SIN COURIER",
        payment: "POR RECAUDAR",
        dateStart: serverTimestamp(),
        dateEnd: ""
      });

      message.success(`Datos enviados correctamente`);
      logUserAction(querydb, auth, "ADD_ORDER", serial,serialDuration, {
        ...dataFormClient,
        ...values,
        fileImage: imgSale ? [imgSale.fileImage] : [],
        status: "Pendiente",
        seller: seller,
        serial: serial,
        courier: "SIN COURIER",
        payment: "POR RECAUDAR",
        items: items,
        dateStart: serverTimestamp(),
        dateEnd: "",
      }, APP_VERSION);
      setDataFormClient("");
      setDataFormProduct("");
      setDataFormSale("");
      setCurrent(0);
    } catch (error) {
      console.log(error);
    }

  };

  const steps = [
    {
      title: "Datos del Cliente",
      content: (
        <StepOne
          next={next}
          setDataFormClient={setDataFormClient}
          dataFormClient={dataFormClient}
        />
      ),
    },
    {
      title: "Datos de Producto",
      content: (
        <>
          <h3 className="titles-formTwo">Datos de Productos</h3>
          <StepTwo
            next={next}
            setDataFormProduct={setDataFormProduct}
            prev={prev}
            dataFormProduct={dataFormProduct}
          />
        </>
      ),
    },
    {
      title: "Información de la Venta ",
      content: (
        <StepThree
          onSubmit={onSubmit}
          setDataFormSale={setDataFormSale}
          prev={prev}
          dataFormSale={dataFormSale}
          order={dataFormProduct}
        />
      ),
    },
  ];

  const items = steps.map((item) => ({
    key: item.title,
    title: item.title,
  }));
  const contentStyle = {
    lineHeight: "260px",
    textAlign: "center",
    color: token.colorTextTertiary,
    backgroundColor: token.colorFillAlter,
    borderRadius: token.borderRadiusLG,
    border: `1px dashed ${token.colorBorder}`,
    marginTop: 16,
    padding: "2% 6% 1%",
  };

  return (
    <>
      <Steps current={current} items={items} />
      <div style={contentStyle}>{steps[current].content}</div>
    </>
  );
};
